import { render } from "./PageThankYou.vue?vue&type=template&id=192b896e&scoped=true"
import script from "./PageThankYou.vue?vue&type=script&lang=js"
export * from "./PageThankYou.vue?vue&type=script&lang=js"

import "./PageThankYou.vue?vue&type=style&index=0&id=192b896e&lang=scss&scoped=true"

import exportComponent from "/Users/adostos/wame/zealy-web-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192b896e"]])

export default __exports__